export const handleNavigate = (data) => {
    const path = `/${data.categoryName.toLowerCase()}/${data.categoryId}/${data.entityType}/details/${data.entityId}`;
    return path

  };